import { createContext, useContext } from 'react';
import { HttpService } from '../common/services/HttpService';
import { GetPosOrderByShopifyIdService } from '../domain/services/orders/GetPosOrderByShopifyId/GetPosOrderByShopifyIdService';
import { GetCustomerRecipeHistoricByShopifyCustomerIdService } from '../domain/services/customer-recipes/GetCustomerRecipeHistoricByShopifyCustomerId/GetCustomerRecipeHistoricByShopifyCustomerIdService';
import { LinkCustomerRecipeToProductGroupService } from '../domain/services/product-recipes/LinkCustomerRecipeToProductGroup/LinkCustomerRecipeToProductGroupService';
import { RemoveProductRecipeLinkingService } from '../domain/services/product-recipes/RemoveProductRecipeLinking/RemoveProductRecipeLinkingService';
import { SendNewOrderRecipeFileService } from '../domain/services/file-repositories/SendNewOrderRecipeFile/SendNewOrderRecipeFileService';
import { DeleteOrderRecipeService } from '../domain/services/order-recipes/DeleteOrderRecipe/DeleteOrderRecipeService';
import { SaveOrderRecipeService } from '../domain/services/order-recipes/SaveOrderRecipe/SaveOrderRecipeService';
import { ValidatePassportService } from '../domain/services/passports/ValidatePassport/ValidatePassportService';
import { AlertService } from '../common/services/AlertService';
import { CreateAndLinkOrderRecipeFromCustomerRecipeService } from '../domain/services/order-recipes/CreateAndLinkOrderRecipeFromCustomerRecipe/CreateAndLinkOrderRecipeFromCustomerRecipeService';
import { CreateCustomerRecipeService } from '../domain/services/customer-recipes/CreateCustomerRecipe/CreateCustomerRecipeService';
import { SendLogMessageService } from '../domain/services/log-messages/SendLogMessage/SendLogMessageService';
import { SearchMemberAccountService } from '../domain/services/zclub/member-accounts/SearchMemberAccount/SearchMemberAccountService';
import { GetMemberAccountByShopifyCustomerIdService } from '../domain/services/zclub/member-accounts/GetMemberAccountByShopifyCustomerId/GetMemberAccountByShopifyCustomerIdService';
import { GetMembershipLevelListService } from '../domain/services/zclub/membership-levels/GetMembershipLevelList/GetMembershipLevelListService';
import { GetMemberAccountPointsHistoryByShopifyCustomerIdService } from '../domain/services/zclub/member-accounts/GetMemberAccountPointsHistoryByShopifyCustomerId/GetMemberAccountPointsHistoryByShopifyCustomerIdService';
import { GetMembershipLevelRewardListService } from '../domain/services/zclub/membership-levels/GetMembershipLevelRewardList/GetMembershipLevelRewardListService';
import { ExchangePointsRewardService } from '../domain/services/zclub/member-accounts/ExchangePointsReward/ExchangePointsRewardService';
import { GetCustomerCashbackDetailsService } from '../domain/services/zclub/cashback/GetCustomerCashbackDetails/GetCustomerCashbackDetails';
import { GetSislogAuthUserService } from '../domain/services/sislog-users/GetAuthUser/GetSislogAuthUserService';

interface IZerezesServices {
  alertService?: AlertService | null;
  getPosOrderByShopifyIdService?: GetPosOrderByShopifyIdService | null;
  getCustomerRecipeHistoricByShopifyCustomerIdService?: GetCustomerRecipeHistoricByShopifyCustomerIdService | null;
  linkCustomerRecipeToProductGroupService?: LinkCustomerRecipeToProductGroupService | null;
  removeProductRecipeLinkingService?: RemoveProductRecipeLinkingService | null;
  sendNewOrderRecipeFileService?: SendNewOrderRecipeFileService | null;
  deleteOrderRecipeService?: DeleteOrderRecipeService | null;
  saveOrderRecipeService?: SaveOrderRecipeService | null;
  validatePassportService?: ValidatePassportService | null;
  createAndLinkOrderRecipeFromCustomerRecipeService?: CreateAndLinkOrderRecipeFromCustomerRecipeService | null;
  createCustomerRecipeService?: CreateCustomerRecipeService | null;
  sendLogMessageService?: SendLogMessageService | null;
  searchMemberAccountService?: SearchMemberAccountService | null;
  getMemberAccountByShopifyCustomerIdService?: GetMemberAccountByShopifyCustomerIdService | null;
  getMembershipLevelListService?: GetMembershipLevelListService | null;
  getMemberAccountPointsHistoryByShopifyCustomerIdService?: GetMemberAccountPointsHistoryByShopifyCustomerIdService | null;
  getMembershipLevelRewardListService?: GetMembershipLevelRewardListService | null;
  exchangePointsRewardService?: ExchangePointsRewardService | null;
  getCustomerCashbackDetailsService?: GetCustomerCashbackDetailsService | null;
  getSislogAuthUserService?: GetSislogAuthUserService | null;
}

const createZerezesServices = (): IZerezesServices => {
  const httpService: HttpService = new HttpService();
  const alertService: AlertService = new AlertService();

  return {
    alertService: alertService,
    getPosOrderByShopifyIdService: new GetPosOrderByShopifyIdService(httpService),
    getCustomerRecipeHistoricByShopifyCustomerIdService: new GetCustomerRecipeHistoricByShopifyCustomerIdService(httpService),
    linkCustomerRecipeToProductGroupService: new LinkCustomerRecipeToProductGroupService(httpService),
    removeProductRecipeLinkingService: new RemoveProductRecipeLinkingService(httpService),
    sendNewOrderRecipeFileService: new SendNewOrderRecipeFileService(httpService),
    deleteOrderRecipeService: new DeleteOrderRecipeService(httpService),
    saveOrderRecipeService: new SaveOrderRecipeService(httpService),
    validatePassportService: new ValidatePassportService(httpService),
    createAndLinkOrderRecipeFromCustomerRecipeService: new CreateAndLinkOrderRecipeFromCustomerRecipeService(httpService),
    createCustomerRecipeService: new CreateCustomerRecipeService(httpService),
    sendLogMessageService: new SendLogMessageService(httpService),
    searchMemberAccountService: new SearchMemberAccountService(httpService),
    getMemberAccountByShopifyCustomerIdService: new GetMemberAccountByShopifyCustomerIdService(httpService),
    getMembershipLevelListService: new GetMembershipLevelListService(httpService),
    getMemberAccountPointsHistoryByShopifyCustomerIdService: new GetMemberAccountPointsHistoryByShopifyCustomerIdService(httpService),
    getMembershipLevelRewardListService: new GetMembershipLevelRewardListService(httpService),
    exchangePointsRewardService: new ExchangePointsRewardService(httpService),
    getCustomerCashbackDetailsService: new GetCustomerCashbackDetailsService(httpService),
    getSislogAuthUserService: new GetSislogAuthUserService(httpService),
  }
}

const ZerezesServicesContext = createContext<IZerezesServices>({});

const ZerezesServicesProvider = (props: any) => {

  const { children } = props;

  const value = createZerezesServices();

  return (
    <ZerezesServicesContext.Provider value={value}>
      {children}
    </ZerezesServicesContext.Provider>
  )
}

const useZerezesServices = () => {
  const context = useContext(ZerezesServicesContext);
  return context;
}

export { ZerezesServicesProvider, useZerezesServices };